// components/project-details/ProjectTabs.js
import React, { useState } from 'react';
import { InformationCircleIcon, ClipboardDocumentListIcon, BanknotesIcon, LockClosedIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import CompletionModal from './CompletionModal';
import styles from './ProjectDetails.module.css';

const ProjectTabs = ({ activeTab, setActiveTab, isProjectStarted, isStripeConnected, project, updateProjectStatus, updatingStatus }) => {
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  
  const tabs = [
    { 
      id: 'enquiry', 
      label: 'Customer Details', 
      icon: InformationCircleIcon, 
      available: true 
    }, 
    { 
      id: 'project', 
      label: 'Project Management', 
      icon: ClipboardDocumentListIcon, 
      available: isProjectStarted 
    },
    { 
      id: 'invoices', 
      label: 'Invoices', 
      icon: BanknotesIcon, 
      available: isProjectStarted,
      requiresStripe: true
    }
  ];

  const handleCompleteProject = () => {
    setShowCompletionModal(false);
    updateProjectStatus(project.id, 'project_completed');
  };

  const renderActionButton = () => {
    if (project.status === 'in_conversation') {
      return (
        <button
          onClick={() => updateProjectStatus(project.id, 'project_started')}
          disabled={updatingStatus}
          className={`${styles.actionButton} ${styles.start}`}
        >
          {updatingStatus ? (
            <div className={styles.spinner} style={{ width: '1rem', height: '1rem' }}></div>
          ) : (
            <CheckCircleIcon style={{ width: '1rem', height: '1rem' }} />
          )}
          Start Project
        </button>
      );
    }

    return null;
  };

  return (
    <>
      <div className={styles.tabsContainer}>
        <nav className={styles.tabsNavFull}>
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const lockedForStripe = tab.requiresStripe && !isStripeConnected;
            return (
              <div key={tab.id} style={{ position: 'relative', flex: 1 }}>
                <button
                  onClick={() => tab.available && setActiveTab(tab.id)}
                  disabled={!tab.available}
                  className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''} ${lockedForStripe ? styles.locked : ''}`}
                  style={{ width: '100%', justifyContent: 'center' }}
                >
                  <Icon style={{ width: '1.25rem', height: '1.25rem' }} />
                  {tab.label}
                  {!tab.available && (
                    <LockClosedIcon style={{ width: '1rem', height: '1rem', color: 'var(--Grey-400)' }} />
                  )}
                  {lockedForStripe && tab.available && (
                    <span className={styles.lockedBadge}>Connect Stripe</span>
                  )}
                </button>
                {!tab.available && (
                  <div className={styles.tabTooltip}>
                    Start project to unlock
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 0,
                      height: 0,
                      borderLeft: '4px solid transparent',
                      borderRight: '4px solid transparent',
                      borderTop: '4px solid var(--Grey-800)'
                    }}></div>
                  </div>
                )}
                {lockedForStripe && tab.available && (
                  <div className={styles.tabTooltip}>
                    Connect Stripe to unlock
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 0,
                      height: 0,
                      borderLeft: '4px solid transparent',
                      borderRight: '4px solid transparent',
                      borderTop: '4px solid var(--Grey-800)'
                    }}></div>
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-s)', paddingRight: 'var(--spacing-l)' }}>
          {renderActionButton()}
        </div>
      </div>

      <CompletionModal
        isOpen={showCompletionModal}
        onClose={() => setShowCompletionModal(false)}
        onConfirm={handleCompleteProject}
        projectName={project.projectName}
      />
    </>
  );
};

export default ProjectTabs;
